import { Location } from '../location';
import { isUndefined } from 'util';
import { TrafficNode } from '../trafficNodes/trafficNode';
/**
 * class {Event}
 * should be used to display event related information
 */
export class Event {
    /**
     * constructor of class
     * please use factory instead
     * @see {this.factory)
     * @param id
     * @param name
     * @param place
     * @param location
     * @param category
     * @param impact
     * @param description
     * @param startTime
     * @param endTime
     * @param affectedStops
     */
    constructor(id, name, city, place, location, category, impact, description, startTime, endTime, affectedStops) {
        this._id = id;
        this._name = name;
        this._city = city;
        this._place = place;
        this._location = location;
        this._category = category;
        this._impact = impact;
        this._description = description;
        this._startTime = startTime;
        this._endTime = endTime;
        this._affectedStops = affectedStops;
    }
    /**
     * Factory method to create an instance of this class without
     * having to correctly fill the constructor.
     * !!! You should always use this instead of the constructor !!!
     * @param values
     * @returns {Event}
     */
    static factory(values) {
        const sanitizedValues = {};
        sanitizedValues.id = !isUndefined(values.id) ? values.id : '';
        sanitizedValues.name = values.name ? values.name : '';
        sanitizedValues.city = values.city ? values.city : '';
        sanitizedValues.place = values.place ? values.place : '';
        sanitizedValues.location = !isUndefined(values.location) ? Location.factory(values.location) : Location.factory({});
        sanitizedValues.category = !isUndefined(values.category) ? values.category : 0;
        sanitizedValues.impact = !isUndefined(values.impact) ? values.impact : 0;
        sanitizedValues.description = values.description ? values.description : '';
        sanitizedValues.startTime = !isUndefined(values.startTime) ? new Date(values.startTime) : undefined;
        sanitizedValues.endTime = !isUndefined(values.endTime) ? new Date(values.endTime) : undefined;
        sanitizedValues.affectedStops = [];
        if (values.affectedStops) {
            for (const stop of values.affectedStops) {
                sanitizedValues.affectedStops.push(TrafficNode.factory(stop));
            }
        }
        return new Event(sanitizedValues.id, sanitizedValues.name, sanitizedValues.city, sanitizedValues.place, sanitizedValues.location, sanitizedValues.category, sanitizedValues.impact, sanitizedValues.description, sanitizedValues.startTime, sanitizedValues.endTime, sanitizedValues.affectedStops);
    }
    /**
     * gets the internal _id
     * @returns {string}
     */
    get id() {
        return this._id;
    }
    /**
     * sets the internal _id
     * @param id
     */
    set id(id) {
        this._id = id;
    }
    /**
     * gets the name of the event
     * @returns {string}
     */
    get name() {
        return this._name;
    }
    /**
     * sets the name of the event
     * @param name
     */
    set name(name) {
        this._name = name;
    }
    /**
     * gets the city of the event
     * @returns {string}
     */
    get city() {
        return this._city;
    }
    /**
     * sets the city of the event
     * @param city
     */
    set city(city) {
        this._city = city;
    }
    /**
     * gets the place of the event
     * @returns {string}
     */
    get place() {
        return this._place;
    }
    /**
     * sets the place of the event
     * @param place
     */
    set place(place) {
        this._place = place;
    }
    /**
     * gets the location information of this event
     * @returns {Location}
     */
    get location() {
        return this._location;
    }
    /**
     * sets the location information of this event
     * @param location
     */
    set location(location) {
        this._location = location;
    }
    /**
     * gets category of this event
     * @returns {EVENT_CATEGORY}
     */
    get category() {
        return this._category;
    }
    /**
     * sets the category of this event
     * @param category
     */
    set category(category) {
        this._category = category;
    }
    /**
     * gets the impact of the event
     * @returns {number}
     */
    get impact() {
        return this._impact;
    }
    /**
     * sets the impact of the event
     * @param impact
     */
    set impact(impact) {
        this._impact = impact;
    }
    /**
     * gets the description of the event
     * @returns {string}
     */
    get description() {
        return this._description;
    }
    /**
     * sets the description of the event
     * @param description
     */
    set description(description) {
        this._description = description;
    }
    /**
     * gets the start time for the event
     * @returns {Date}
     */
    get startTime() {
        return this._startTime;
    }
    /**
     * sets the start time for the event
     * @param startTime
     */
    set startTime(startTime) {
        this._startTime = startTime;
    }
    /**
     * gets the end time for the event
     * @returns {Date}
     */
    get endTime() {
        return this._endTime;
    }
    /**
     * sets the end time for the event
     * @param endTime
     */
    set endTime(endTime) {
        this._endTime = endTime;
    }
    /**
     * gets the end time for the event
     * @returns {affectedStops}
     */
    get affectedStops() {
        return this._affectedStops;
    }
    /**
     * sets the end time for the event
     * @param affectedStops
     */
    set affectedStops(affectedStops) {
        this._affectedStops = affectedStops;
    }
}
//# sourceMappingURL=events.js.map